// Sticky-header scroll state + mega nav (desktop panel / mobile sheet) + page behaviours.
// Keep this file tiny — most interactivity in a Shopify theme comes from plain
// links and forms.
(function () {
  // --- Sticky header: add a translucent, blurred backdrop once scrolled ---
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('pp-header--scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // --- Mega nav: shared morphing panel + mobile sheet ---
  // Mirrors src/components/Navbar.astro on petpavilion.ae so the two sites stay in step.
  (function () {
    var header = document.getElementById('pn-header');
    var panel = document.getElementById('pn-panel');
    var caret = document.getElementById('pn-caret');
    var sheet = document.getElementById('pn-sheet');
    var burger = document.getElementById('pn-burger');
    if (!header || !panel || !caret || !sheet || !burger) return;

    var triggers = Array.prototype.slice.call(header.querySelectorAll('.pn-trigger'));
    var bar = header.querySelector('.pn-bar');
    var activeKey = null;
    var closeTimer = 0;
    var openTimer = 0;

    var menuFor = function (key) { return document.getElementById('pn-menu-' + key); };
    var triggerFor = function (key) {
      for (var i = 0; i < triggers.length; i++) if (triggers[i].getAttribute('data-menu') === key) return triggers[i];
      return null;
    };

    // ---- desktop panel ----
    function place(key, animate) {
      var trigger = triggerFor(key);
      var menu = menuFor(key);
      if (!trigger || !menu) return;
      var hb = header.getBoundingClientRect();
      var tb = trigger.getBoundingClientRect();
      var w = Number(menu.getAttribute('data-width'));
      var h = menu.offsetHeight;
      var center = tb.left - hb.left + tb.width / 2;
      // Centre under the trigger, but stay within the page's content gutters.
      var bb = bar.getBoundingClientRect();
      var pad = parseFloat(getComputedStyle(bar).paddingLeft) || 0;
      var minLeft = Math.max(16, bb.left - hb.left + pad);
      var maxLeft = Math.min(hb.width - w - 16, bb.right - hb.left - pad - w);
      var left = maxLeft < minLeft
        ? Math.max(16, Math.round((hb.width - w) / 2))
        : Math.max(minLeft, Math.min(Math.round(center - w / 2), maxLeft));
      if (!animate) { panel.style.transition = 'none'; caret.style.transition = 'none'; }
      panel.style.width = w + 'px';
      panel.style.height = h + 'px';
      panel.style.left = left + 'px';
      caret.style.left = Math.round(center - left - 7) + 'px';
      if (!animate) { void panel.offsetWidth; panel.style.transition = ''; caret.style.transition = ''; }
    }

    function open(key) {
      if (activeKey === key) return;
      var wasOpen = activeKey !== null;
      var prev = activeKey ? menuFor(activeKey) : null;
      var next = menuFor(key);
      if (!next) return;
      var dir = prev ? (Number(next.getAttribute('data-index')) > Number(prev.getAttribute('data-index')) ? 1 : -1) : 0;
      if (prev) { prev.classList.remove('is-active'); prev.style.setProperty('--dx', (-18 * dir) + 'px'); }
      next.style.setProperty('--dx', (18 * dir) + 'px');
      void next.offsetWidth; // start the incoming menu from its offset
      next.classList.add('is-active');
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-menu') === key ? 'true' : 'false'); });
      place(key, wasOpen);
      panel.classList.add('is-open');
      activeKey = key;
    }

    function close() {
      if (!activeKey) return;
      var menu = menuFor(activeKey);
      if (menu) menu.classList.remove('is-active');
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      panel.classList.remove('is-open');
      activeKey = null;
    }

    var scheduleClose = function () { clearTimeout(closeTimer); clearTimeout(openTimer); closeTimer = window.setTimeout(close, 140); };
    var cancelClose = function () { clearTimeout(closeTimer); };

    triggers.forEach(function (t) {
      var key = t.getAttribute('data-menu');
      t.addEventListener('mouseenter', function () {
        cancelClose(); clearTimeout(openTimer);
        openTimer = window.setTimeout(function () { open(key); }, activeKey ? 0 : 60);
      });
      t.addEventListener('click', function () { cancelClose(); clearTimeout(openTimer); if (activeKey === key) close(); else open(key); });
      t.addEventListener('focus', cancelClose);
    });
    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', scheduleClose);
    var primary = header.querySelector('.pn-primary');
    var actions = header.querySelector('.pn-actions');
    var logo = header.querySelector('.pn-logo');
    if (primary) primary.addEventListener('mouseleave', scheduleClose);
    if (actions) actions.addEventListener('mouseenter', scheduleClose);
    if (logo) logo.addEventListener('mouseenter', scheduleClose);
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', function (e) { if (!header.contains(e.relatedTarget)) close(); });
    window.addEventListener('resize', function () { if (activeKey) place(activeKey, false); });

    // ---- mobile sheet ----
    var closeBtn = sheet.querySelector('#pn-sheet-close');
    var openSheet = function () {
      sheet.hidden = false;
      burger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    };
    var closeSheet = function () {
      if (sheet.hidden) return;
      sheet.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      burger.focus();
    };
    burger.addEventListener('click', openSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    window.addEventListener('resize', function () { if (window.innerWidth > 991) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') { close(); closeSheet(); } });
  })();

  // --- Collection: sort dropdown auto-submits (keeps tag filters in the URL path) ---
  var sortSelect = document.querySelector('[data-pp-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var form = sortSelect.closest('form');
      if (form) form.submit();
    });
  }

  // --- Product page (PDP) ---
  var pdp = document.querySelector('[data-pp-pdp]');
  if (pdp) {
    var slice = function (list) { return Array.prototype.slice.call(list); };

    // Money: mirror the store's money format ("Dhs. {{amount}}") without a server round-trip.
    var moneyFormat = pdp.getAttribute('data-money-format') || '{{amount}}';
    var saveTemplate = pdp.getAttribute('data-save-template') || '';
    var formatMoney = function (cents) {
      var noDecimals = /no_decimals/.test(moneyFormat);
      var amount = (cents / 100).toFixed(noDecimals ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };

    // Gallery: thumbnails swap the main image; the strip scrolls with arrows or by swiping.
    var mainImg = pdp.querySelector('#pp-pdp-main');
    var thumbs = slice(pdp.querySelectorAll('[data-pp-thumb]'));
    var thumbsWrap = pdp.querySelector('[data-pp-thumbs-wrap]');
    var thumbsList = pdp.querySelector('[data-pp-thumbs]');
    var activeIndex = 0;

    var showImage = function (index) {
      var thumb = thumbs[index];
      if (!thumb) return;
      var full = thumb.getAttribute('data-full');
      if (mainImg && full) {
        mainImg.src = full;
        mainImg.removeAttribute('srcset');
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      activeIndex = index;
      // Keep the active thumbnail in view inside the strip (no page scroll).
      if (thumbsList) {
        var li = thumb.parentNode;
        var left = li.offsetLeft;
        var right = left + li.offsetWidth;
        if (left < thumbsList.scrollLeft || right > thumbsList.scrollLeft + thumbsList.clientWidth) {
          thumbsList.scrollTo({ left: Math.max(0, left - 8), behavior: 'smooth' });
        }
      }
    };
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showImage(i); });
    });

    if (thumbsWrap && thumbsList) {
      var updateOverflow = function () {
        thumbsWrap.classList.toggle('has-overflow', thumbsList.scrollWidth > thumbsList.clientWidth + 4);
      };
      updateOverflow();
      window.addEventListener('resize', updateOverflow);
      var stepThumbs = function (dir) {
        thumbsList.scrollBy({ left: dir * thumbsList.clientWidth * 0.8, behavior: 'smooth' });
      };
      var thumbsPrev = pdp.querySelector('[data-pp-thumbs-prev]');
      var thumbsNext = pdp.querySelector('[data-pp-thumbs-next]');
      if (thumbsPrev) thumbsPrev.addEventListener('click', function () { stepThumbs(-1); });
      if (thumbsNext) thumbsNext.addEventListener('click', function () { stepThumbs(1); });
    }

    if (mainImg && thumbs.length > 1) {
      var touchX = null;
      mainImg.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      mainImg.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) < 40) return;
        var n = thumbs.length;
        showImage((activeIndex + (dx < 0 ? 1 : -1) + n) % n);
      }, { passive: true });
    }

    // Variant data + the bits of the page that change with the selection.
    var variantData = [];
    var dataEl = pdp.querySelector('[data-pp-variant-data]');
    if (dataEl) {
      try { variantData = JSON.parse(dataEl.textContent); } catch (e) { variantData = []; }
    }
    var idSelect = pdp.querySelector('[data-pp-id]');
    var priceBox = pdp.querySelector('[data-pp-price]');
    var totalBox = pdp.querySelector('[data-pp-total]');
    var stickyPriceEl = pdp.querySelector('[data-pp-sticky-price]');
    var addBtn = pdp.querySelector('[data-pp-add]');
    var addText = pdp.querySelector('[data-pp-add-text]');
    var stickyAdd = pdp.querySelector('[data-pp-sticky-add]');
    var pills = slice(pdp.querySelectorAll('[data-pp-pill]'));
    var bundles = slice(pdp.querySelectorAll('[data-pp-bundle]'));
    var qtyInput = pdp.querySelector('[data-pp-qty]');
    var qtyDown = pdp.querySelector('[data-pp-qty-down]');
    var qtyUp = pdp.querySelector('[data-pp-qty-up]');

    var getQty = function () {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      return isNaN(n) || n < 1 ? 1 : n;
    };

    var findVariant = function () {
      var chosen = {};
      pills.forEach(function (input) {
        if (input.checked) chosen[input.getAttribute('data-pp-pill')] = input.value;
      });
      return variantData.filter(function (v) {
        var opts = v.options || [];
        for (var pos in chosen) {
          if (opts[pos - 1] !== chosen[pos]) return false;
        }
        return true;
      })[0];
    };

    // Fill a price box: <s data-pp-compare>, <span data-pp-current>, <span data-pp-save>.
    // textContent only — values are numbers from the variant data, never user input.
    var setPriceBox = function (box, price, compare) {
      if (!box) return;
      var compareEl = box.querySelector('[data-pp-compare]');
      var currentEl = box.querySelector('[data-pp-current]');
      var saveEl = box.querySelector('[data-pp-save]');
      var onSale = compare > price;
      if (currentEl) currentEl.textContent = formatMoney(price);
      if (compareEl) {
        compareEl.hidden = !onSale;
        compareEl.textContent = onSale ? formatMoney(compare) : '';
      }
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(((compare - price) / compare) * 100);
          saveEl.textContent = saveTemplate.replace('[amount]', formatMoney(compare - price)).replace('[percent]', String(pct));
        }
      }
    };

    // Volume-style savings: the largest tier whose quantity fits the chosen quantity.
    var savingsFor = function (qty) {
      var bestQty = 0;
      var best = 0;
      bundles.forEach(function (b) {
        var q = parseInt(b.getAttribute('data-qty'), 10) || 1;
        var s = parseInt(b.getAttribute('data-save'), 10) || 0;
        if (q <= qty && q >= bestQty) { bestQty = q; best = s; }
      });
      return best;
    };

    var updateBuyState = function (variant) {
      var available = !!(variant && variant.available);
      [addBtn, stickyAdd].forEach(function (btn) { if (btn) btn.disabled = !available; });
      if (addText) {
        if (!variant) {
          addText.textContent = addText.getAttribute('data-unavailable') || addText.textContent;
        } else if (available) {
          addText.textContent = addText.getAttribute('data-available') || addText.textContent;
        } else {
          addText.textContent = addText.getAttribute('data-soldout') || addText.textContent;
        }
      }
    };

    var render = function () {
      var variant = findVariant();
      var qty = getQty();

      bundles.forEach(function (b) {
        b.checked = parseInt(b.getAttribute('data-qty'), 10) === qty;
      });
      if (idSelect && variant) idSelect.value = variant.id;

      if (variant) {
        var unitCompare = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
        setPriceBox(priceBox, variant.price, unitCompare);
        if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);

        bundles.forEach(function (b) {
          var q = parseInt(b.getAttribute('data-qty'), 10) || 1;
          var s = parseInt(b.getAttribute('data-save'), 10) || 0;
          var lineTotal = Math.round((variant.price * q * (100 - s)) / 100);
          var lineCompare = (unitCompare || variant.price) * q;
          var card = b.nextElementSibling;
          var totalEl = card && card.querySelector('[data-pp-bundle-total]');
          var compareEl = card && card.querySelector('[data-pp-bundle-compare]');
          if (totalEl) totalEl.textContent = formatMoney(lineTotal);
          if (compareEl) {
            var show = lineCompare > lineTotal;
            compareEl.hidden = !show;
            compareEl.textContent = show ? formatMoney(lineCompare) : '';
          }
        });

        var save = savingsFor(qty);
        var total = Math.round((variant.price * qty * (100 - save)) / 100);
        var totalCompare = (unitCompare || variant.price) * qty;
        setPriceBox(totalBox, total, totalCompare > total ? totalCompare : 0);

        // Show the variant's own photo when it has one.
        if (variant.featured_image && variant.featured_image.id) {
          var idx = -1;
          thumbs.forEach(function (t, i) {
            if (String(t.getAttribute('data-image-id')) === String(variant.featured_image.id)) idx = i;
          });
          if (idx > -1) showImage(idx);
        }
      }
      updateBuyState(variant);
    };

    pills.forEach(function (input) { input.addEventListener('change', render); });
    bundles.forEach(function (input) {
      input.addEventListener('change', function () {
        if (qtyInput) qtyInput.value = input.getAttribute('data-qty') || '1';
        render();
      });
    });
    var stepQty = function (delta) {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, getQty() + delta);
      render();
    };
    if (qtyDown) qtyDown.addEventListener('click', function () { stepQty(-1); });
    if (qtyUp) qtyUp.addEventListener('click', function () { stepQty(1); });
    if (qtyInput) qtyInput.addEventListener('change', render);

    // Sticky bar: submit the main form on click; reveal once the main button scrolls away.
    var form = pdp.querySelector('[data-pp-form]');
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
    var stickyBar = pdp.querySelector('[data-pp-sticky]');
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
        });
      }, { rootMargin: '0px 0px -120px 0px' });
      io.observe(addBtn);
    }

    // Related products: fetch the recommendations section, then inject it.
    var recs = pdp.querySelector('[data-pp-recommendations]');
    if (recs && recs.getAttribute('data-url')) {
      fetch(recs.getAttribute('data-url'))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var inner = parsed.querySelector('.pp-recs');
          if (inner) recs.appendChild(inner);
        })
        .catch(function () {});
    }
  }

  // --- Collection: mobile filter drawer ---
  var filters = document.querySelector('[data-pp-filters]');
  var openBtn = document.querySelector('[data-pp-filters-open]');
  var closeBtn = document.querySelector('[data-pp-filters-close]');
  var overlay = document.querySelector('[data-pp-filters-overlay]');
  if (filters && openBtn) {
    var openFilters = function () {
      filters.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.hidden = false;
      document.body.classList.add('pp-no-scroll');
    };
    var closeFilters = function () {
      filters.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.hidden = true;
      document.body.classList.remove('pp-no-scroll');
    };
    openBtn.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (overlay) overlay.addEventListener('click', closeFilters);
    document.addEventListener('keydown', function (event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && filters.classList.contains('is-open')) {
        closeFilters();
        openBtn.focus();
      }
    });
  }

  // --- Staggered scroll reveal for [data-pp-reveal] groups ---
  var reveals = Array.prototype.slice.call(document.querySelectorAll('[data-pp-reveal]'));
  if (reveals.length) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      // No motion (or no observer support): just show everything immediately.
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      reveals.forEach(function (el) { el.classList.add('pp-reveal-ready'); });
      var revealObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { revealObserver.observe(el); });
    }
  }

  // --- Product carousel ([data-pp-carousel]) ---
  var carousels = Array.prototype.slice.call(document.querySelectorAll('[data-pp-carousel]'));
  carousels.forEach(function (carousel) {
    var track = carousel.querySelector('[data-pp-carousel-viewport]');
    var prev = carousel.querySelector('[data-pp-carousel-prev]');
    var next = carousel.querySelector('[data-pp-carousel-next]');
    if (!track) return;

    var amount = function () { return Math.max(track.clientWidth * 0.9, 200); };
    var update = function () {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    };

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
